"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBarApiImpl = void 0;
const StatusBarRedux_1 = require("../../Redux/ActionsReducers/StatusBarRedux");
const ApiBase_1 = require("./ApiBase");
class StatusBarApiImpl extends ApiBase_1.ApiBase {
    getAdaptableStatusBars() {
        return (0, StatusBarRedux_1.getStatusPanelsSelector)(this.getAdaptableState());
    }
    getAgGridStatusPanels() {
        return this.adaptable.getAgGridStatusPanels();
    }
    getAgGridStatusBar() {
        return this.adaptable.getAgGridStatusPanels();
    }
    setStatusBarPanels(statusPanels) {
        this.dispatchAction((0, StatusBarRedux_1.StatusBarSetPanels)(statusPanels));
    }
}
exports.StatusBarApiImpl = StatusBarApiImpl;
